import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";
import { CasinoLink } from "./CasinoLink.jsx";
import HomeSeoText from "../../Pages/Casino/HomeSeoText.jsx";

export class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.renderItems = this.renderItems.bind(this);
        this.renderGroup = this.renderGroup.bind(this);
        this.renderLinkGroup = this.renderLinkGroup.bind(this);
    }

    renderItems() {
        return Object.keys(this.props.footer).map((item) => {
            return (
                <div className="group clearfix" key={item}>
                    <h3>{item}</h3>
                    {this.renderGroup(this.props.footer[item])}
                </div>
            )
        });
    }

    renderGroup(group) {
        return Object.keys(group).map((name) => {
            var item = group[name];

            if (item.isGroup)
                return this.renderLinkGroup(name, item);

            if (name=='Tecaj')
                return <div key="tecaj" className="link-group tecaj">{item}</div>

            if (item.className)
                return <a key={item.url} href={item.url}><span className={item.className}></span></a>

            if (item.url.startsWith('http') || item.url.startsWith('mailto')) {
                if (this.props.user || !item.authenticated) {
                    return (<a key={item.url} href={item.url}><span>{name}</span></a>);
                }
                return null;
            }

            return (
                < NavLink to = { this.props.getHomePathFn(this.props.route.location, item.url) } key = { item.url } >
                    <span>{name}</span>
                </NavLink>
            )
        });
    }

    render() {
        return (
            <section key="footer" id="footer" className="clearfix">
                <div className="footer-content">
                    {/*<div className="footer-main">*/}
                    {/*    {this.renderItems()}*/}
                    {/*</div>*/}
                    <HomeSeoText key="text" {...this.props} />
                    <div className="disclaimer-content">
                        <div className="disclaimer">
                            <img src="content/images/assets/18_icon.png" alt="18 Plus logo" />
                            <span>
                                Igre na sreću mogu uzrokovati ovisnost, molimo vas da odgovorno igrate.<br />
                                Za više informacija posjetite našu stranicu za  <a onClick={() => location.href = 'https://mcasino.supersport.hr/pravila/odgovorno-igranje'}>Odgovorno igranje</a>.
                            </span>
                        </div>
                    </div>

                    <div className="desktop">
                        <CasinoLink key="desktop" href={casino.config.urls.desktopVerzija}>
                            <span className="icon ico-tv-outline"></span>
                            <span>Desktop verzija</span>
                        </CasinoLink>
                    </div>
                </div>
            </section>
        )
    }

    renderLinkGroup(name, item) {
        return (
            <div key = { name } className = { 'link-group ' + name } >
                {this.renderGroup(item.items)}
            </div>
        )
    }
};